import React from 'react';
import styled from 'styled-components';
// import { Collapse, Button } from 'antd';
import { FlexBoxCenter } from 'styles';

export const WhiteWrapper = styled.div`
  padding: 16px 18px;
  margin-bottom: 16px;
  background: #ffffff;

  .ant-table-row:hover {
    cursor: pointer;
  }
`;

export const SearchFormWrapper = styled(FlexBoxCenter)`
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 16px 18px;
  margin-bottom: 16px;
  background: #ffffff;
  border-bottom: 1px solid #dcdcdccc;

  .ant-select.ant-select-single.ant-select-show-arrow {
    .ant-select-selector {
      width: 200px;
      height: 38px;
      .ant-select-selection-item {
        line-height: 38px;
      }
    }
  }
`;

export const MonthQuickFilterWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(13, minmax(0, 1fr));
  width: 100%;
  gap: 8px;
`;

export const MonthQuickFilterButton = styled.button<{ $isActive?: boolean }>`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid ${({ $isActive }) => ($isActive ? '#D7D8DC' : '#D7D8DC')};
  border-radius: 4px;
  background: ${({ $isActive }) => ($isActive ? '#212529' : '#ffffff')};
  color: ${({ $isActive }) => ($isActive ? '#ffffff' : '#4b5563')};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  transition: all 0.2s ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
    background: #f7f7f7;
    color: #d7d8dc;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;

  .ant-table-thead > tr > th {
    text-align: center !important;
  }

  .ant-table-content {
    .ant-table-thead > tr > th {
      height: 40px;
      /* padding: 16px; */
      padding: 0;
      background: #f2f4f6;
      border: none;
      font-size: 14px;
      font-weight: 700;
      line-height: 18px;
    }

    .ant-table-tbody > tr > td {
      height: 40px;
      padding: 10px;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
    }

    .ant-table-tbody > tr.table-row-fixed > td,
    .ant-table-tbody > tr.table-row-fixed:hover > td {
      background: #edf7f0;
    }
  }
`;

export const TextUnderline = styled.span`
  color: #3478f6;
  cursor: pointer;
  text-decoration-line: underline;
`;

export const DividerWrapper = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #6d7582;
`;
export const Divider = () => <DividerWrapper>|</DividerWrapper>;

export const Chip = ({ label, isActive }: { label: React.ReactNode | string; isActive?: boolean }) => {
  const defaultColor = typeof isActive !== 'boolean' ? '#212529' : '#d3d3d3';
  const defaultBorderColor = typeof isActive !== 'boolean' ? '#707070' : '#d3d3d3';

  return (
    <div
      style={{
        padding: '0 8px',
        borderRadius: '6px',
        fontWeight: '500',
        border: `1px solid ${isActive ? '#46b476' : defaultBorderColor}`,
        color: isActive ? '#46b476' : defaultColor
      }}
    >
      {label}
    </div>
  );
};

export const StatusChip = ({ label, isActive, style }: { label: React.ReactNode | string; isActive?: boolean; style?: any }) => {
  const defaultColor = typeof isActive !== 'boolean' ? '#858585' : '#ffffff';
  const defaultBackgroundColor = typeof isActive !== 'boolean' ? '#eeeeee' : '#212529';

  return (
    <div
      style={{
        width: 'fit-content',
        padding: '4px 8px',
        margin: '0px auto',
        background: isActive ? '#46b476' : defaultBackgroundColor,
        borderRadius: '8px',
        fontWeight: '700',
        color: isActive ? '#ffffff' : defaultColor,
        ...style
      }}
    >
      {label}
    </div>
  );
};

export const Wrapper = styled(TableWrapper)`
  display: flex;
  align-items: normal;
  flex-direction: column;
  gap: 10px;
  padding: 16px 18px;
  margin-bottom: 16px;
  background: #ffffff;

  .ant-tabs-nav-list,
  .ant-tabs-tab {
    width: 100%;
    margin: 0;
    justify-content: center;
  }
  .ant-tabs-nav {
    .ant-tabs-nav-operations,
    .ant-tabs-nav-operations.ant-tabs-nav-operations-hidden {
      display: none;
    }
  }
  .table-row-error {
    background: #ffebe6;
  }
  .ant-tabs-nav-operations {
    display: none;
  }
`;

export const FormWrapper = styled(TableWrapper)`
  display: flex;

  .fieldName {
    min-width: 120px;
    min-height: 40px;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(242, 244, 246);
    padding: 0px 16px;
    border: '1px solid #f0f0f0';
  }
  .ant-table-wrapper {
    width: 100%;
    .ant-table-content {
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        padding: 0px 16px;
      }
    }
  }
`;

export const TabsWrapper = styled(TableWrapper)`
  padding: 0px 18px 16px;
  background: #ffffff;

  .ant-tabs-nav-list,
  .ant-tabs-tab {
    width: 100%;
    margin: 0;
    justify-content: center;
  }
  .ant-tabs-nav {
    .ant-tabs-nav-operations,
    .ant-tabs-nav-operations.ant-tabs-nav-operations-hidden {
      display: none;
    }
  }
  .table-row-error {
    background: #ffebe6;
  }
  .ant-tabs-nav-operations {
    display: none;
  }

  .ant-select-selector {
    display: none;
  }
`;
